module.exports = __webpack_public_path__ + "media/images/icons/add-comment-908af09ee553de88651c816f67c22313.svg";